import React from 'react';
import { AuthContext } from '../../authContext';
const useIdentityUser = () => {
    const { identity: { user }, } = React.useContext(AuthContext);
    return user;
};
export default useIdentityUser;
